/**
 * Отложенный вызов на время синхронного блока: пока выполняется run(fn),
 * вызовы, которые спросили deferIfRunning(), не выполняются, а после блока
 * call() выполняется ровно один раз — если его хоть раз откладывали.
 *
 * Нужен сцене: перерисовка по обновлению стора синхронная и полная, а шаг
 * бота — это несколько диспатчей подряд в одной задаче. Промежуточные
 * перерисовки на экран не попадают никогда (Phaser рисует кадр только в
 * requestAnimationFrame), так что достаточно одной — по итоговому состоянию.
 *
 * Блоки могут вкладываться: отложенный вызов выполняется после внешнего.
 * Ошибка внутри fn пробрасывается дальше, отложенный вызов при этом все равно
 * выполняется.
 */
export const createDeferredCallGate = (call) => {
  let depth = 0;
  let isCallPending = false;

  return {
    run(fn) {
      depth += 1;
      try {
        return fn();
      } finally {
        depth -= 1;
        if (depth === 0 && isCallPending) {
          isCallPending = false;
          call();
        }
      }
    },

    // true — вызов отложен до конца блока, выполнять его сейчас не нужно
    deferIfRunning() {
      if (depth === 0) {
        return false;
      }
      isCallPending = true;
      return true;
    },
  };
};
